import PropTypes from 'prop-types'
import React from 'react'

import Cost, { CostPreloader } from 'components/Cost'
import DiscountLabel from 'components/DiscountLabel'

import {
  CrossedCostBlock,
  SubscriptionText,
  SubscriptionTextWrapper,
  MutedCostBox,
} from './styles'

/**
 * CartCostBlock
 *
 * @param {object} props - properties of component
 * @returns {node} CartCostBlock
 */
const CartCostBlock = props => {
  const {
    intlCode,
    currencyCode,
    dictForKit,
    dictCart,
    discount,
    realCost,
    cost,
    isSubscription,
    isLoading,
    showDiscount,
    showCrossedCost,
    precision,
    size,
  } = props

  return (
    <>
      {showCrossedCost && (
        <CrossedCostBlock>
          <MutedCostBox>
            {isLoading ? (
              <CostPreloader className="mr-1 mr-md-2" size="cart" />
            ) : (
              <Cost
                className="mr-1 mr-md-2"
                value={realCost}
                intlCode={intlCode}
                currency={currencyCode}
                size={size}
                strikethrough={true}
                precision={precision}
              />
            )}
          </MutedCostBox>
          {showDiscount && dictCart && discount && !isLoading && (
            <DiscountLabel
              text={dictCart.labels.discount}
              isShortLabel={
                realCost > 99999
              } /* should hide word 'discount' for big cost */
              value={discount}
            />
          )}
        </CrossedCostBlock>
      )}
      <SubscriptionTextWrapper>
        {isLoading ? (
          <CostPreloader size="cart" />
        ) : (
          <Cost
            value={cost}
            intlCode={intlCode}
            currency={currencyCode}
            size={size}
            precision={precision}
          />
        )}
        {isSubscription && dictForKit && (
          <SubscriptionText
            dangerouslySetInnerHTML={{
              __html: dictForKit.types.subscription.terms,
            }}
          />
        )}
      </SubscriptionTextWrapper>
    </>
  )
}

CartCostBlock.propTypes = {
  cost: PropTypes.number.isRequired,
  currencyCode: PropTypes.string.isRequired,
  intlCode: PropTypes.string.isRequired,
  realCost: PropTypes.number.isRequired,
  showCrossedCost: PropTypes.bool.isRequired,
  dictCart: PropTypes.object,
  dictForKit: PropTypes.object,
  discount: PropTypes.number,
  precision: PropTypes.number,
  isSubscription: PropTypes.bool,
  showDiscount: PropTypes.bool,
  isLoading: PropTypes.bool,
  size: PropTypes.string,
}

CartCostBlock.defaultProps = {
  showDiscount: false,
  isSubscription: false,
  size: 'cart',
}

export default CartCostBlock
